import { Icon } from "@iconify/react";
import { animateScroll as animatescroll } from "react-scroll";
import { Link as RouterLink } from "react-router-dom";
import { Link as ScrollLink, animateScroll as scroll } from "react-scroll";
import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
const addressDataList = ["address line ", "phone number", "website url"];
const serviceMenuList = [
  {
    title: "Facebook Ads",
    href: "/service/service-details",
  },
  {
    title: "Google Ads",
    href: "/service/service-details",
  },
  {
    title: "Tick Tok Ads",
    href: "/service/service-details",
  },
  {
    title: "Taboola",
    href: "/service/service-details",
  },
  {
    title: "Outbrain",
    href: "/service/service-details",
  },
  {
    title: "E-commerce",
    href: "/service/service-details",
  },
  {
    title: "Copywriting",
    href: "/service/service-details",
  },
];
const LinksMenuList = [
  {
    title: "Home",
    onClick: () => animatescroll.scrollToTop({ duration: 500 }),
  },
  {
    title: "Who we are",
    href: "about",
  },
  {
    title: "Services",
    href: "service",
  },
  {
    title: "Recommendation",
    href: "recommendation",
  },
  {
    title: "Blogs",
    to: "/blog-list",
  },
  {
    title: "Contact",
    href: "contact",
  },
];
const policyMenuList = [
  {
    title: "Terms of Use",
    href: "/",
  },
  {
    title: "Privacy Policy",
    href: "/",
  },
];
const socialBtnList = [
  {
    icon: "fa6-brands:linkedin-in",
    href: "/",
  },
  {
    icon: "fa6-brands:twitter",
    href: "/",
  },
  {
    icon: "fa6-brands:youtube",
    href: "/",
  },
  {
    icon: "fa6-brands:facebook-f",
    href: "/",
  },
];
export default function Footer() {
  const { t } = useTranslation("marketing");
  return (
    <>
      <div></div>

      <footer
        className="cs_fooer cs_bg_filed"
        // style={{ backgroundImage: 'url(/images/footer_bg.jpeg)' }}
      >
        <div className="cs_fooer_main">
          <div className="container">
            <div className="row">
              <div className="col-lg-3 col-sm-6">
                <div className="cs_footer_item">
                  <div className="cs_text_widget">
                    <img alt="" src="/others-image/Halisi-white1.png"></img>
                  </div>
                  <ul className="cs_menu_widget cs_mp0">
                    {addressDataList.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className="col-lg-3 col-sm-6">
                <div className="cs_footer_item">
                  <h2 className="cs_widget_title">{t("footer.services")}</h2>
                  <ul className="cs_menu_widget cs_mp0">
                    {serviceMenuList.map((item, index) => (
                      <li key={index}>
                        <p>{item.title}</p>
                        {/* <Link to={item.href}>{item.title}</Link> */}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className="col-lg-3 col-sm-6">
                <div className="cs_footer_item">
                  <h2 className="cs_widget_title">{t("footer.links")}</h2>
                  <ul className="cs_menu_widget cs_mp0">
                    {LinksMenuList.map((item, index) => (
                      <li key={index}>
                        {item.href ? (
                          <ScrollLink
                            style={{ cursor: "pointer" }}
                            to={item.href}
                            smooth={true}
                            duration={500}
                            onClick={item.onClick}
                            onMouseEnter={(e) =>
                              (e.target.style.color = "#005D9F")
                            }
                            onMouseLeave={(e) =>
                              (e.target.style.color = "#fff")
                            }
                          >
                            {item.title}
                          </ScrollLink>
                        ) : (
                          <RouterLink to={item.to} onClick={item.onClick}>
                            {item.title}
                          </RouterLink>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className="col-lg-3 col-sm-6">
                <div className="cs_footer_item">
                  <h2 className="cs_widget_title">Subscribe Newsletter </h2>
                  <div className="cs_newsletter cs_style_1">
                    <div className="cs_newsletter_text">
                      We make sure to only send emails that are noteworthy and
                      pertinent to the recipient.
                    </div>
                    <form action="#" className="cs_newsletter_form">
                      <input
                        type="email"
                        className="cs_newsletter_input"
                        placeholder="Email address"
                      />
                      <button className="cs_btn cs_style_1">
                        Submit
                        <span>
                          <i>
                            <Icon icon="fa6-solid:arrow-right" />
                          </i>
                          <i>
                            <Icon icon="fa6-solid:arrow-right" />
                          </i>
                        </span>
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="cs_bottom_footer">
            <div className="cs_bottom_footer_left">
              <div className="cs_social_btns cs_style_1">
                {socialBtnList.map((item, index) => (
                  <Link to={item.href} className="cs_center" key={index}>
                    <Icon icon={item.icon} />
                  </Link>
                ))}
              </div>
            </div>
            <div className="cs_copyright">
              Copyright &copy; {new Date().getFullYear()} Halisi Marketing. All
              Rights Reserved. Made with 
              <span style={{ color: "#F5773E", fontWeight: "bold" }}>
                Single
              </span>
              Bit.
            </div>
            <div className="cs_bottom_footer_right">
              <ul className="cs_footer_links cs_mp0">
                {policyMenuList.map((item, index) => (
                  <li key={index}>
                    <Link to={item.href}>{item.title}</Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
